import Grid from "@mui/material/Grid2";
import { FormGroup } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Controller, useFormContext } from "react-hook-form";
import { Fragment, ReactNode } from "react";
import FormField from "components/cck/FormField";
import type { CalculationMethodFormByTypeProps } from "@schemas/calculationmethods/schema";
import NumberInput from "components/cck/NumberInput";
import { AgreementTypeEnum } from "__generated__/graphql";

type FormValues = {
	agreements: {
		type?: AgreementTypeEnum;
		calculationMethod: {
			price?: number;
			customUnit?: string;
		}
	}[];
}

type FormField = {
	id: string;
	render: () => ReactNode;
}


const LumpsumCalculationMethodForm = ({ index, currency, hiddenFields }: CalculationMethodFormByTypeProps) => {
	const { control, formState: { errors } } = useFormContext<FormValues>();

	const LumpsumCalculationMethodFormFields: FormField[] = [
		{
			id: "calculationMethod.price",
			render: () => (
				<Grid size={4}>
					<FormField errors={errors} name={`agreements.${index}.calculationMethod.price`}>
						<FormGroup label={intl.formatMessage({ id: "PRICE" })} overflow="hidden" required>
							<Controller
								name={`agreements.${index}.calculationMethod.price`}
								control={control}
								rules={{ required: true }}
								render={({ field }) => (
									<NumberInput
										{...field}
										addonBefore={currency.symbol} />
								)} />
						</FormGroup>
					</FormField>
				</Grid>
			),
		},
	];

	return (
		<>
			{LumpsumCalculationMethodFormFields
				.filter(x => !hiddenFields?.includes(x.id))
				.map(x => (
					<Fragment key={x.id}>
						{x.render()}
					</Fragment>
				))
			}
		</>
	);
};

export default LumpsumCalculationMethodForm;
